import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/design-system';
import { navigate } from '@/app/router';

interface Props {
  children: ReactNode;
}
interface State {
  failed: boolean;
}

export class EditorErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Editor canvas failed safely', {
      name: error.name,
      componentStack: info.componentStack,
    });
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <section
        role="alert"
        className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center"
      >
        <h1 className="text-xl font-semibold">Não foi possível renderizar o editor</h1>
        <p className="max-w-md text-sm text-text-secondary">
          Seu funil não foi alterado. Volte ao painel e tente abri-lo novamente.
        </p>
        <Button variant="secondary" onClick={() => navigate('/app')}>
          Voltar ao painel
        </Button>
      </section>
    );
  }
}
